var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v(" Copyright "),_c('a-icon',{attrs:{"type":"copyright"}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.copyright)}}),_vm._v("  "),_c('span',[_vm._v("伊顿电力设备有限公司")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }